(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jolat-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStickyCta(scope) {
    var root = scope && scope.querySelector ? scope : document;
    var sticky = root.querySelector('[data-jl-sticky]');
    var hero = root.querySelector('[data-jl-hero]');
    if (!sticky) { return; }
    if (sticky._jlObserver) { sticky._jlObserver.disconnect(); }
    if (!hero || !('IntersectionObserver' in window)) {
      sticky.classList.add('jl-sticky--show');
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          sticky.classList.remove('jl-sticky--show');
        } else {
          sticky.classList.add('jl-sticky--show');
        }
      });
    }, { threshold: 0, rootMargin: '-48px 0px 0px 0px' });
    observer.observe(hero);
    sticky._jlObserver = observer;
  }

  function boot() { initStickyCta(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('[data-jl-sticky]')) {
      initStickyCta(event.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
